import React from 'react';
import { Save } from 'lucide-react';

interface ActionsSidebarProps {
  isDefault: boolean;
  onDefaultChange: (checked: boolean) => void;
  saving: boolean;
  isValid: boolean;
  onCancel: () => void;
}

export default function ActionsSidebar({
  isDefault,
  onDefaultChange,
  saving,
  isValid,
  onCancel,
}: ActionsSidebarProps) {
  return (
    <div className="bg-white border rounded-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-gray-700">Set sebagai Default</label>
        <button
          type="button"
          onClick={() => onDefaultChange(!isDefault)}
          className={`relative w-12 h-6 rounded-full transition-colors duration-200 ${
            isDefault ? 'bg-blue-600' : 'bg-gray-300'
          }`}
        >
          <span
            className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 ${
              isDefault ? 'translate-x-6' : 'translate-x-0'
            }`}
          />
        </button>
      </div>

      <button
        type="submit"
        disabled={saving || !isValid}
        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
      >
        <Save className="w-4 h-4" />
        {saving ? 'Menyimpan...' : 'Simpan Model'}
      </button>

      <button
        type="button"
        onClick={onCancel}
        className="w-full px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
      >
        Batal
      </button>
    </div>
  );
}
